package devxertech.com.pages.services.devOperation

import androidx.compose.runtime.Composable
import devxertech.com.seo.ServiceJsonLd
import devxertech.com.seo.PageMetadata
import devxertech.com.seo.PageSeo
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonAboutSection
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.services.devOperation.devLifeCycles.DevOpsLifeCycle
import devxertech.com.pages.services.devOperation.devMobDevelopment.DevMobileSection
import devxertech.com.pages.services.devOperation.devService.DevServices
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import devxertech.com.utils.Res.Image.dev_about

@Page("/dev-operation")
@Composable
fun DevOperationSection() {
    PageMetadata(PageSeo.DevOps)
    ServiceJsonLd("/dev-operation", PageSeo.DevOps, "DevOps")
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            imageAlt = "DevOps development illustration",
            mainHeadingAsH1 = true,
            image = Res.Image.dev_Header,
            breakpoint = breakpoint,
            headingText = "DevOps",
            descriptionText = "Consistent, Reliable and high-performance-Our " +
                    "DevOps services provides for a high-quality Software environment"
            )
        CommonArrow("Dev Operation")
//        DevAboutSection(breakpoint)
        CommonAboutSection(
            breakpoint = breakpoint,
            title = "What’s the Secret Behind",
            firstFont = "Devxer Devops path for an idea to go",
            secondFont = "From Concept to Customer?",
            description = "The Devxer DevOps path transforms ideas into customer-ready solutions by integrating agile workflows, " +
                    "automated pipelines, and continuous feedback. Starting with concept validation, " +
                    "it streamlines development, ensures rigorous testing, and deploys seamlessly to production. " +
                    "Each step is designed to prioritize quality, scalability, and rapid delivery.",
            imageName = dev_about, devModification = true

        )
        DevServices()
        DevOpsLifeCycle()
        MakeYourOwnTeam(breakpoint)
        DevMobileSection(breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}
